import { forwardRef } from 'react';
import { useController } from 'react-hook-form';
import MenuItem from '@mui/material/MenuItem';
import { TextField } from './TextField';

export const Select = forwardRef(({ value, onChange, tooltip, options = [], children, ...rest }, ref) => {
  return (
    <TextField ref={ref} select value={value} onChange={onChange} tooltip={tooltip} {...rest}>
      {children ??
        options.map(({ label, value: optionValue, disabled }) => (
          <MenuItem key={optionValue} value={optionValue} disabled={disabled}>
            {label}
          </MenuItem>
        ))}
    </TextField>
  );
});

/** Select integrated with React Hook Form */
export const RhfSelect = ({ control, name, ...rest }) => {
  const { field, fieldState } = useController({
    name,
    control,
  });

  return <Select {...field} {...rest} error={!!fieldState.error} helperText={fieldState.error?.message} />;
};
